const Promise = require('bluebird')
const $ = require('jquery')
const Vue = require('vue')

Vue.component('sorter', {
    template: `
            <div class="table-with-sortable-header">
                <slot></slot>
            </div>
        `,
    props: {
        columns: {
            type: Object,
            twoWay: true,
            default: {}
        }
    },
    ready () {
        const $el = $(this.$el)
        $el.find('>table>thead>tr').addClass('header-grey')
    },
    methods: {
        sort (column) {
            if (!this.columns.hasOwnProperty(column)) {
                this.columns = {
                    ...this.columns,
                    [column]: 'DESC'
                }
                return 'DESC'
            } else if (this.columns[column] === 'DESC') {
                this.columns = {
                    ...this.columns,
                    [column]: 'ASC'
                }
                return 'ASC'
            } else {
                delete this.columns[column]
                this.columns = { ...this.columns }
                return null
            }
        }
    }
})

Vue.component('sorterCol', {
    replace: true,
    template: `
            <span class="sorter__sorter-col">
                <slot></slot>
                <a href="javascript:;" class="sorter__sort-icon" v-on:click.prevent="sort()" v-bind:class="getClass()" v-tooltip :title="name">
                    <i class="glyphicon glyphicon" v-bind:class="getIconClass()"></i>
                </a>
            </span>
        `,
    props: {
        field: String
    },
    data () {
        return {
            state: null
        }
    },
    ready () {
        if (this.$parent.columns.hasOwnProperty(this.field)) {
            this.state = this.$parent.columns[this.field]
        } else {
            this.state = null
        }
    },
    computed: {
        name () {
            let state = null
            if (this.$parent.columns.hasOwnProperty(this.field)) {
                state = this.$parent.columns[this.field]
            }

            if (state === 'ASC') {
                return 'Ordem ascendente'
            } else if (state === 'DESC') {
                return 'Ordem descendente'
            }

            return 'Ordem padrão'
        }
    },
    methods: {
        sort () {
            this.state = this.$parent.sort(this.field)
        },
        getClass () {
            if (this.state === null) {
                return 'not-in-use'
            } else {
                return 'in-use'
            }
        },
        getIconClass () {
            if (this.state === 'ASC') {
                return 'glyphicon-sort-by-attributes'
            } else if (this.state === 'DESC') {
                return 'glyphicon-sort-by-attributes-alt'
            }

            return 'glyphicon-sort'
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/sorter.js